import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import ElementUI from 'element-ui'
import './plugins/element.js'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import './assets/css/custom.css'
import './assets/iconfont/iconfont.css'

//高德地图
import VueAmap from 'vue-amap'
import VueTianditu from "vue-tianditu";
Vue.use(VueTianditu, {
  v: "4.0",
  tk: "f05e9ec66c7f541b1e87a84896e0de20"
});

Vue.use(VueAmap)
// 初始化vue-amap
VueAmap.initAMapApiLoader({
  key: '8f167cc1987476c7515b71d716a4dd14',// 高德的key
  // 插件集合
  plugin: [
    'AMap.Geolocation',  //定位空间，用来获取和展示用户主机所在的经纬度位置
    'AMap.Autocomplete',  //输入提示插件
    'AMap.PlaceSearch', //POI搜索插件
    'AMap.Scale',   //右下角缩略图插件，比例尺
    'AMap.OverView', //地图鹰眼插件
    'AMap.ToolBar',  //地图工具条
    'AMap.MapType',  //类别切换空间，实现默认图层与卫星图，实施交通层之间切换的控制
    'AMap.PolyEditor', //编辑 折线多边形
    'AMap.CircleEditor',
    'AMap.Geocoder'    //地图编码
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0'
})
//高德的安全密钥
window._AMapSecurityConfig = {
  securityJsCode: '541c070e8ee4ad0c9603ec9bb6fddd40'
}
import axios from 'axios'

import components from '@/utils/components.js'
import '@/permission'

Vue.use(ElementUI)
Vue.use(components)

Vue.prototype.$axios = axios
Vue.prototype.EventBus = new Vue()
Vue.filter('formatDate', function (val) { // val表示要被处理的数据
  // 过滤器业务逻辑，要有返回值
  val = val ? val * 1000 : null
  let date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  return Y + M + D + h + m
})
Vue.filter('formatDay', function (val) { // val表示要被处理的数据
  if (!val && val != 0) return
  if (isNaN(val)) {
    val = Math.round(new Date(val) / 1000)
  }
  //格式化时间
  val = val ? val * 1000 : null
  let date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-'
  let M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  return Y + M + D

})
Vue.directive('loadmore', {
  bind(el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector(
      '.el-select-dropdown .el-select-dropdown__wrap'
    )

    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight + 1
      if (CONDITION) {
        binding.value()
      }
    })
  }
})
Vue.directive('scrollLoad', {
  bind(el, binding) {
    let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap')
    wrapDom.addEventListener(
      'scroll',
      function () {
        let condition = this.scrollHeight - this.scrollTop - 2 <= this.clientHeight
        console.log(this.scrollHeight - this.scrollTop)
        console.log(this.clientHeight)
        if (condition) {
          //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
          binding.value()
        }
      }
    )
  }
})
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
